import { AfterContentInit, Component, ElementRef, Input, inject } from '@angular/core';
import { AbstractControl, FormsModule } from '@angular/forms';

import { CustomTooltipMessagesComponent } from '../validation/custom-tooltip-messages.component';
import { ValidationMessagesComponent } from '../validation/validation-messages.component';
import { ValidationHelperService } from './validation-helper.service';

/**
 * @beta
 */
@Component({
    imports: [FormsModule, CustomTooltipMessagesComponent, ValidationMessagesComponent],
    selector: 'vn-validation-field',
    templateUrl: 'validation-field.component.html',
})
export class ValidationFieldComponent implements AfterContentInit {
    private validationHelper = inject(ValidationHelperService);
    private elementRef = inject(ElementRef);

    @Input() validationMessages: any;
    @Input() showTooltips: boolean | string[];
    @Input() showSuccessValidation = false;
    @Input() layout: string;
    @Input() ignoreMaxLength: boolean;

    @Input() triggerValidationsOnChange = false;

    @Input() control!: AbstractControl | null;
    get element(): HTMLElement {
        return this.elementRef.nativeElement;
    }

    get additionalTooltips(): any[] {
        return this.showTooltips instanceof Array ? this.showTooltips : [];
    }

    private get isInput(): boolean {
        return this.element.tagName === 'INPUT';
    }

    ngAfterContentInit() {
        if (this.isInput && !this.ignoreMaxLength) {
            const input = this.element as HTMLInputElement;
            const rules = this.validationHelper.getRules(input.name);

            if (rules?.maxLength) {
                input.maxLength = rules.maxLength;
            }
        }
    }
}
